import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AddEditModalGeneric } from '../../../../ui/generics';
import { IArticleLabel } from '../../core/interfaces/IArticleLabel';
import { ArticleLabelTypes, ArticleLabelTypesDisplayNames } from '../../core/enums/ArticleLabelTypes';
import { IArticle } from '../../../../core/interfaces';

@Component({
    selector: 'app-add-edit-round-label-modal',
    templateUrl: './add-edit-round-label-modal.component.html',
    styleUrl: './add-edit-round-label-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditRoundLabelModalComponent extends AddEditModalGeneric<IArticleLabel, any> {

  @Input() labelType: ArticleLabelTypes;
  @Input() article: IArticle;
  @Input() articleVariantIds: number[];

  public readonly articleLabelTypesDisplayNames = ArticleLabelTypesDisplayNames;

  public constructor(
    protected cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }
}
